// Reading window.localStorage throws when site data is blocked.
export const hasStorage = () => {
  try {
    return !!(
      window.localStorage &&
      window.localStorage.setItem &&
      window.localStorage.getItem
    );
  } catch (e) {
    return false;
  }
};

// Missing, unreadable, or older than maxAgeMs all return null.
export const readCache = (key, maxAgeMs) => {
  if (!hasStorage()) return null;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const { value, cachedAt } = JSON.parse(raw);
    if (typeof cachedAt !== 'number') return null;
    if (Date.now() - cachedAt > maxAgeMs) return null;
    return value;
  } catch (e) {
    return null;
  }
};

export const writeCache = (key, value) => {
  if (!hasStorage()) return;
  try {
    window.localStorage.setItem(
      key,
      JSON.stringify({ value, cachedAt: Date.now() }),
    );
  } catch (e) {
    // Storage full or disabled.
  }
};

export const clearCache = (key) => {
  if (!hasStorage()) return;
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    // Storage disabled.
  }
};
